import { createApp } from "vue";
import { createPinia } from "pinia";
import Settings from "./admin/settings.vue";

import "./assets/admin.scss";
import "./assets/base.scss";

const app = createApp(Settings);


app.use(createPinia());
app.mount("#fpe-admin-settings");
